// CTC is always captured as the full figure in rupees - a whole number or a
// number with up to two decimals (820000 or 820000.50), never a shorthand
// like 8.2 lakhs.
const CTC_TYPING_PATTERN = /^\d{0,12}(\.\d{0,2})?$/;
const CTC_VALUE_PATTERN = /^\d{1,12}(\.\d{1,2})?$/;
const MIN_CTC_IN_RUPEES = 1000;

// Accepts the half typed states too ("820000." on the way to "820000.50"),
// so it can be used to block keystrokes while the user types.
export const isCtcInputAllowed = (value) => CTC_TYPING_PATTERN.test(value);

export const validateCtc = (value, label) => {
  const ctc = String(value ?? "").trim();
  if (ctc === "") {
    return { status: true, message: `${label} is required` };
  }
  if (!CTC_VALUE_PATTERN.test(ctc)) {
    return {
      status: true,
      message: `${label} must be a number, only up to two decimals are allowed`,
    };
  }
  if (Number(ctc) < MIN_CTC_IN_RUPEES) {
    return {
      status: true,
      message: `${label} must be the full amount in rupees (e.g. 820000, not 8.2)`,
    };
  }
  return { status: false, message: "" };
};

// Existing records can hold non numeric text or a placeholder 0 where no CTC was
// ever captured. Show those as blank so the field reads as unfilled instead of
// showing NaN or a 0.00 that will not pass validation anyway.
export const toCtcAmount = (value) => {
  const amount = Number(value);
  return value === null || value === "" || value === undefined || isNaN(amount) || amount === 0
    ? ""
    : amount.toFixed(2);
};
